export default __webpack_public_path__ + "static/media/pago-bancomat.7442e91e.svg";